export default __webpack_public_path__ + "static/1788-18c23bcba28abeff5511b03e65019bf3.gif";